import "flowbite";
import { CookieConsentModal } from "./js/CookieConsentModal";
import { Carousels } from "./js/Carousels";
import { ApplyForJob } from "./js/ApplyForJob";
import { MobileNavigation } from "./js/MobileNavigation";
import { PaintRevealOverlay } from "./js/PaintRevealOverlay.js";
import { ScrollViewAnimation } from "./js/ScrollViewAnimation.js";

const initApp = () => {
  const targetContainer = document.getElementById("reveal-canvas");
  const overlayInstance = new PaintRevealOverlay(targetContainer, {
    overlayColor: "#2e2e2e",
    onComplete: () => {
      document.body.classList.remove("overflow-hidden");
    },
  });
  CookieConsentModal();
  MobileNavigation();
  Carousels();
  ApplyForJob();
  initFlowbite();
  ScrollViewAnimation();
};

window.addEventListener("load", () => {
  setTimeout(() => {
    initApp();
  }, 500);
});
